export default __webpack_public_path__ + "static/media/meme-ories.682dbfab.png";